import { createSelector } from 'reselect';

import getContentArchive from './getContentArchiveBase';

const getArchivedPagination = createSelector(
  [getContentArchive],
  ({ pagination } = {}) => pagination,
);

export default getArchivedPagination;
